/* tslint:disable */
/* eslint-disable */
/**
 * Proxy microservice (dev)
 * Proxy microservice for application
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CustomMovementEventFilter
 */
export interface CustomMovementEventFilter {
    /**
     * 
     * @type {Array<string>}
     * @memberof CustomMovementEventFilter
     */
    action?: Array<CustomMovementEventFilterActionEnum>;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof CustomMovementEventFilter
     */
    caseInsensitive?: { [key: string]: boolean; };
    /**
     * 
     * @type {string}
     * @memberof CustomMovementEventFilter
     */
    container?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomMovementEventFilter
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomMovementEventFilter
     */
    destiny?: string;
    /**
     * 
     * @type {Date}
     * @memberof CustomMovementEventFilter
     */
    endDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof CustomMovementEventFilter
     */
    family?: string;
    /**
     * 
     * @type {Date}
     * @memberof CustomMovementEventFilter
     */
    initDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof CustomMovementEventFilter
     */
    material?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomMovementEventFilter
     */
    operatorCode?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomMovementEventFilter
     */
    origin?: string;
    /**
     * 
     * @type {number}
     * @memberof CustomMovementEventFilter
     */
    quantity?: number;
    /**
     * 
     * @type {string}
     * @memberof CustomMovementEventFilter
     */
    searchText?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomMovementEventFilter
     */
    user?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomMovementEventFilter
     */
    warehouse?: string;
}


/**
 * @export
 */
export const CustomMovementEventFilterActionEnum = {
    Consumption: 'CONSUMPTION',
    Entrance: 'ENTRANCE',
    Exit: 'EXIT',
    InventoryActivation: 'INVENTORY_ACTIVATION',
    InventoryDeactivation: 'INVENTORY_DEACTIVATION',
    InventoryInbound: 'INVENTORY_INBOUND',
    InventoryOutbound: 'INVENTORY_OUTBOUND',
    Movement: 'MOVEMENT',
    Reactivation: 'REACTIVATION',
    Regularization: 'REGULARIZATION'
} as const;
export type CustomMovementEventFilterActionEnum = typeof CustomMovementEventFilterActionEnum[keyof typeof CustomMovementEventFilterActionEnum];


/**
 * Check if a given object implements the CustomMovementEventFilter interface.
 */
export function instanceOfCustomMovementEventFilter(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CustomMovementEventFilterFromJSON(json: any): CustomMovementEventFilter {
    return CustomMovementEventFilterFromJSONTyped(json, false);
}

export function CustomMovementEventFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomMovementEventFilter {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'action': !exists(json, 'action') ? undefined : json['action'],
        'caseInsensitive': !exists(json, 'caseInsensitive') ? undefined : json['caseInsensitive'],
        'container': !exists(json, 'container') ? undefined : json['container'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'destiny': !exists(json, 'destiny') ? undefined : json['destiny'],
        'endDate': !exists(json, 'endDate') ? undefined : (new Date(json['endDate'])),
        'family': !exists(json, 'family') ? undefined : json['family'],
        'initDate': !exists(json, 'initDate') ? undefined : (new Date(json['initDate'])),
        'material': !exists(json, 'material') ? undefined : json['material'],
        'operatorCode': !exists(json, 'operatorCode') ? undefined : json['operatorCode'],
        'origin': !exists(json, 'origin') ? undefined : json['origin'],
        'quantity': !exists(json, 'quantity') ? undefined : json['quantity'],
        'searchText': !exists(json, 'searchText') ? undefined : json['searchText'],
        'user': !exists(json, 'user') ? undefined : json['user'],
        'warehouse': !exists(json, 'warehouse') ? undefined : json['warehouse'],
    };
}

export function CustomMovementEventFilterToJSON(value?: CustomMovementEventFilter | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'action': value.action,
        'caseInsensitive': value.caseInsensitive,
        'container': value.container,
        'description': value.description,
        'destiny': value.destiny,
        'endDate': value.endDate === undefined ? undefined : (value.endDate.toISOString()),
        'family': value.family,
        'initDate': value.initDate === undefined ? undefined : (value.initDate.toISOString()),
        'material': value.material,
        'operatorCode': value.operatorCode,
        'origin': value.origin,
        'quantity': value.quantity,
        'searchText': value.searchText,
        'user': value.user,
        'warehouse': value.warehouse,
    };
}

